const swiper = new Swiper('.swiper-reels', {
  slidesPerView: "1",
  spaceBetween: 16,
  centeredSlides: true,
  loop: true,
  
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1280: {
      slidesPerView: 4,
      spaceBetween: 24,
    },
  },
  
  navigation: {
    nextEl: '.go-next',
    prevEl: '.go-prev',
  },

  slideToClickedSlide: true,
  
  on: {
    init: function () {
      setupSlideClicks(this);
    },
    slideChangeTransitionEnd: function () {
      handleVideoPlayback(this);
    },
  },
});  